import calendarShift from "@/store/layouts/calendarShift/calendarShift";
import kpiLayout from "@/store/layouts/kpi/kpiLayout";
import workflow from "@/store/layouts/workFlow/workflow";
import manLoad from "@/store/layouts/manLoad/manLoad";
import routeStore from "@/store/layouts/stuffs/routeStore";
import commonList from "@/store/layouts/common/commonList"
import customizedDiagram from "@/store/layouts/stuffs/customizedDiagramStore";
import jsonInputConfigStore from "@/store/layouts/common/JsonInputConfigStore";
import dictionaryEnumStore from "@/store/layouts/common/dictionaryEnumStore";
import queryViewStore from "@/store/layouts/common/queryViewStore";
import queryConfigStore from "@/store/layouts/common/queryConfigStore";

const entities = {
    calendarShift,
    kpiLayout,
    workflow,
    manLoad,
    routeStore,
    commonList,
    customizedDiagram,
    jsonInputConfigStore,
    dictionaryEnumStore,
    queryViewStore,
    queryConfigStore,
}

export default entities
